/**
 * CoPilotTriggerButton Component
 *
 * Button to toggle the CoPilot sidebar.
 * Emits copilotRequested event via the CoPilot Context Provider.
 */

import { Sparkles } from '@tonnie/assets';
import { useTranslation } from '@tonnie/locale';
import { Button, cn } from '@tonnie/ui';

import { useCoPilotSidebar, useCoPilotContext } from '@/core/contexts/CoPilotContextProvider';

interface ICoPilotTriggerButtonProps {
  className?: string;
  prompt?: string;
}

export function CoPilotTriggerButton({ className, prompt }: ICoPilotTriggerButtonProps) {
  const { t } = useTranslation();
  const { toggle, isOpen } = useCoPilotSidebar();
  const { emit } = useCoPilotContext();

  const handleClick = () => {
    toggle();
    emit({ type: 'copilotRequested', payload: { trigger: 'button', prompt } });
  };

  return (
    <Button
      variant="ghost"
      size="icon"
      data-testid="copilot-trigger"
      onClick={handleClick}
      className={cn(
        'relative',
        isOpen && 'bg-sidebar-accent text-sidebar-accent-foreground',
        className
      )}
    >
      <Sparkles className="w-5 h-5" />
      <span className="sr-only">{t('copilot.toggle')}</span>
    </Button>
  );
}

export default CoPilotTriggerButton;
